import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            loadingIndicator: {
                paddingTop: theme.spacing(4),
            },
            frameReset: {
                padding: `0px ${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
            },
            mainBox: {
                overflow: 'visible',
                paddingTop: theme.spacing(1),
                marginBottom: `-${theme.spacing(1)}px`,
            },
            breadcrumbLink: {
                cursor: 'pointer',
            },
            actionBar: {
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                padding: theme.spacing(2),
                columnGap: theme.spacing(2),
                rowGap: theme.spacing(1),
            },
            cancelButton: {
                width: '13rem',
                maxWidth: '100%',
                [theme.breakpoints.up('md')]: {
                    order: 2,
                    marginLeft: 'auto',
                },
            },
            saveButton: {
                width: '13rem',
                maxWidth: '100%',
                [theme.breakpoints.up('md')]: {
                    order: 3,
                },
            },
            deleteButton: {
                width: '13rem',
                maxWidth: '100%',
                [theme.breakpoints.only('xs')]: {
                    marginTop: theme.spacing(2),
                },
                [theme.breakpoints.up('md')]: {
                    order: 1,
                },
            },
            banner: {
                marginTop: theme.spacing(2),
            },
        }),
    {
        name: 'EditUser-',
    },
);
